import React from 'react'

/**
 * HOC that injects the result of one or several hooks to the wrapped component props
 * @param {...Function} hooks - The hooks to be executed
 *
 * @return {any} The wrapped component
 */
export default function withHooks(...hooks) {
  return Component =>
    function withHooks(props) {
      return <Component {...hooks.reduce((result, hook) => ({ ...result, ...hook(result) }), props)} />
    }
}
